import { useStore } from '../useStore';

export const useUser = () => {
  const store = useStore();

  return {
    currentUser: store.currentUser,
    setCurrentUser: store.setCurrentUser,
    isAuthenticated: !!store.currentUser,
    isCEO: store.currentUser?.role === 'CEO',
    isManager: store.currentUser?.role === 'MANAGER'
  };
};